import { prependModuleName } from '@/utils/vueUtils';
// eslint-disable-next-line no-shadow
var ESupplyInfoDialogMutations;
(function (ESupplyInfoDialogMutations) {
    ESupplyInfoDialogMutations["SET_IS_SUPPLY_INFO_DIALOG_OPEN"] = "SET_IS_SUPPLY_INFO_DIALOG_OPEN";
    ESupplyInfoDialogMutations["SET_SUPPLIERS_INFO"] = "SET_SUPPLIERS_INFO";
    ESupplyInfoDialogMutations["RESET_SUPPLIERS_INFO"] = "RESET_SUPPLIERS_INFO";
})(ESupplyInfoDialogMutations || (ESupplyInfoDialogMutations = {}));
const ISupplyInfoDialogActionTypes = {
    setIsSupplyInfoDialogOpen: 'setIsSupplyInfoDialogOpen',
    setSuppliersInfo: 'setSuppliersInfo',
    resetSuppliersInfo: 'resetSuppliersInfo',
};
const ISupplyInfoDialogActionTypePath = prependModuleName('supplyInfoDialog', ISupplyInfoDialogActionTypes);
export { ESupplyInfoDialogMutations, ISupplyInfoDialogActionTypes, ISupplyInfoDialogActionTypePath, };
